import { render, staticRenderFns } from "./theTabbar.vue?vue&type=template&id=47216c51&scoped=true&"
import script from "./theTabbar.vue?vue&type=script&lang=js&"
export * from "./theTabbar.vue?vue&type=script&lang=js&"
import style0 from "./theTabbar.vue?vue&type=style&index=0&id=47216c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47216c51",
  null
  
)

export default component.exports